import { useContext } from "react";

import { ConfigContext } from "$src/core/contexts/config";

const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context.config;
};

export const useConfigGracefully = () => {
  const context = useContext(ConfigContext);
  if (!context) return undefined;
  return context.config;
};

export default useConfig;
